import React from 'react';
import SplitMicrosoftEmailButton from './SplitMicrosoftEmail/SplitMicrosoftEmailButton';
import RemoveInvalidEmailButton from './RemoveInvalidEmail/RemoveInvalidEmailButton';
import SelfServeMagicLinkInjectionButton from './SelfServeMagicLinkInjection/SelfServeMagicLinkInjectionButton';
import SaveMxRecordButton from './SaveMXRecord/SaveMxRecordButton';
import SimulateThrottleCSVButton from './SimulateThrottleCSV/SimulateThrottleCSVButton';
import AddToExemptionsButton from './AddToThrottleExemptions/AddToExemptionsButton';

export default function Utilities() {
  return (
    <>
      <ul>
        <li>
          <SplitMicrosoftEmailButton />
        </li>
        <li>
          <RemoveInvalidEmailButton />
        </li>
        <li>
          <SelfServeMagicLinkInjectionButton />
        </li>
        <li>
          <SaveMxRecordButton />
        </li>
        <li>
          <SimulateThrottleCSVButton />
        </li>
        <li>
          <AddToExemptionsButton />
        </li>
      </ul>
    </>
  );
}
